import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { useIAdvize } from '~/composables/_next/useIAdvize';
export default defineNuxtPlugin(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
  var _useNuxt2App, $flag, _useIAdvize, loadIAdvize;
  return regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _useNuxt2App = useNuxt2App(), $flag = _useNuxt2App.$flag;
        _useIAdvize = useIAdvize(), loadIAdvize = _useIAdvize.loadIAdvize;
        if (!$flag.get('iAdvizeEnabled')) {
          _context.next = 5;
          break;
        }
        _context.next = 5;
        return loadIAdvize();
      case 5:
      case "end":
        return _context.stop();
    }
  }, _callee);
})));